import httpClient from "./httpClient";

export interface FetchAllParams {
  offset?: number;
  limit?: number;
  sort?: string;
  bodyParams?: Record<string, any>;
}

abstract class BaseEntityService<T> {
  protected httpClient = httpClient;
  protected constructor(protected readonly serviceUrlSuffix: string) {}

  async fetchAll({
    offset = 0,
    limit = 10,
    sort = "",
    bodyParams = {},
  }: FetchAllParams): Promise<{ data: T[]; total: number }> {
    const params = {
      offset: String(offset),
      limit: String(limit),
      ...(sort && { sort }),
    };
    const queryString = new URLSearchParams(params).toString();
    const response = await httpClient.post(
      `${this.serviceUrlSuffix}/query?${queryString}`,
      bodyParams
    );
    return {
      data: response.data.data,
      total: response.data.metadata.total, // Assume server response includes `total`
    };
  }

  async fetchById(id: string): Promise<T> {
    const response = await httpClient.get(`${this.serviceUrlSuffix}/${id}`);
    return response.data;
  }

  //use only when you try to get a full ArangoId in a format CollectionName/_key and make sure you use lowercase collection name
  async fetchDocumentByFullId(id: string): Promise<T> {
    const response = await httpClient.get(`v1/${id}`);
    return response.data;
  }

  async create(data: Partial<T>): Promise<T> {
    const response = await httpClient.post(this.serviceUrlSuffix, data);
    return response.data;
  }

  async update(id: string, data: Partial<T>): Promise<T> {
    const response = await httpClient.put(
      `${this.serviceUrlSuffix}/${id}`,
      data
    );
    return response.data;
  }

  async deleteById(id: string): Promise<void> {
    await httpClient.delete(`${this.serviceUrlSuffix}/${id}`);
  }
}

export default BaseEntityService;
